import React, {Fragment, useState} from "react";
import {Button, Container, Grid, Header, Icon, Rating} from "semantic-ui-react";
import {FacebookProvider, LoginButton} from 'react-facebook';
import {FormattedMessage} from "react-intl";
import {isEmpty, isUndefined} from "lodash";
import {postScore} from "../../../redux/actions";
import {APP} from "../../../constants";

export const Evaluate = ({place_id, score_avg}) => {

    const [user, setUser] = useState(JSON.parse(localStorage.getItem('_USER')) || {});
    const [loading, setLoading] = useState(false);

    const handleRate = async (e, {rating}) => {

        setLoading(true);

        const data = {
            people: {
                fbid: user.profile.id,
                name: user.profile.name,
                email: user.profile.email,
                avatar: user.profile.picture.data.url
            },
            place_id,
            score: rating
        };

        try {

            const res = await postScore(data);

            alert('Avaliação registrada com sucesso!');
        } catch (e) {

            console.log('error', e);
        } finally {

            setLoading(false);
        }

    }

    const login = (response) => {

        localStorage.setItem('_USER', JSON.stringify(response));

        setUser(response);
    }

    const logout = () => {

        localStorage.removeItem('_USER');

        setUser({});
    }

    return (
        <Container as="section" id={"comments"} className="section-comments">
            <Header as="h2" className="mb-0">
                <FormattedMessage id="Avaliar"/>
            </Header>

            <Container className="details-comments">
                {
                    isEmpty(user) ? <FacebookProvider
                        id={'facebook-comments'}
                        language={'pt_BR'}
                        appId={APP.fbid}
                    >
                        <LoginButton
                            scope="email"
                            onCompleted={login}
                            onError={(error) => console.log(error)}
                            className={"ui facebook button"}
                        >
                            <Icon name='facebook'/> <FormattedMessage id="Login via Facebook"/>
                        </LoginButton>
                    </FacebookProvider> : <Fragment>
                        <Grid columns={"equal"}>
                            <Grid.Column>
                                {user.profile.first_name}, <FormattedMessage id="qual a sua avaliação?"/>
                            </Grid.Column>
                            <Grid.Column>
                                {!isUndefined(score_avg) && <Rating
                                    maxRating={5}
                                    defaultRating={score_avg}
                                    icon='star'
                                    size='huge'
                                    onRate={handleRate}
                                />}

                                <Button
                                    basic
                                    size={"mini"}
                                    onClick={logout}
                                    content={"Sair"}
                                    floated={"right"}
                                />
                            </Grid.Column>
                        </Grid>
                    </Fragment>
                }
            </Container>
        </Container>
    );
};
